import { TypeGuard } from './guards/type/type.guard';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

// Guards
import { AuthGuard } from './guards/auth/auth.guard';
import { RoleGuard } from './guards/role/role.guard';
import { CompleteGuard } from './guards/complete/complete.guard';
import { UnauthGuard } from './guards/unauth/unauth.guard';

// Auth
import { LoginComponent } from './pages/login/login.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { SignupStatusComponent } from './pages/signup-status/signup-status.component';

// Signup Unified
import { SignupUnifiedBasicComponent } from './pages/signup-unified-basic/signup-unified-basic.component';
import { SignupUnifiedPersonComponent } from './pages/signup-unified-person/signup-unified-person.component';
import { SignupUnifiedCompanyComponent } from './pages/signup-unified-company/signup-unified-company.component';

// Dashboard
import { DashSidebarComponent } from './components/dash-sidebar/dash-sidebar.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DashboardSecurityComponent } from './pages/dashboard-security/dashboard-security.component';
import { DashboardRequestAcessComponent } from './pages/dashboard-request-acess/dashboard-request-acess.component';
import { DashboardOrganizationComponent } from './pages/dashboard-organization/dashboard-organization.component';
import { DashboardSettingsComponent } from './pages/dashboard-settings/dashboard-settings.component';
import { DashboardDraftsComponent } from './pages/dashboard-drafts/dashboard-drafts.component';
import { DashboardAgentsComponent } from './pages/dashboard-agents/dashboard-agents.component';
import { DashboardDocumentsComponent } from './pages/dashboard-documents/dashboard-documents.component';
import { DashboardZeroingFundsComponent } from './pages/dashboard-zeroing-funds/dashboard-zeroing-funds.component';
import { DashboardAuditComponent } from './pages/dashboard-audit/dashboard-audit.component';

import { DashboardApprovalComponent } from './pages/dashboard-approval/dashboard-approval.component';
import { DashboardFundApprovalComponent } from './pages/dashboard-fund-approval/dashboard-fund-approval.component';
import { DashboardDocumentModelComponent } from './pages/dashboard-document-model/dashboard-document-model.component';
import { DashboardFundsComponent } from './pages/dashboard-funds/dashboard-funds.component';
import { DashboardProvidersComponent } from './pages/dashboard-providers/dashboard-providers.component';
import { DashboardUserListComponent } from './pages/dashboard-user-list/dashboard-user-list.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { RedirectUserComponent } from './pages/redirect-user/redirect-user.component';

import { DashboardFundApprovalRegisterComponent } from './pages/dashboard-fund-approval-register/dashboard-fund-approval-register.component';
import { DashboardAccountsComponent } from './pages/dashboard-accounts/dashboard-accounts.component';
import { DashboardWitnessesComponent } from './pages/dashboard-witnesses/dashboard-witnesses.component';
import { DashboardRepresentativeApprovalComponent } from './pages/dashboard-representative-approval/dashboard-representative-approval.component';
import { DashboardInvitesComponent } from './pages/dashboard-invites/dashboard-invites.component';
import { DashboardGroupUsersComponent } from './pages/dashboard-group-users/dashboard-group-users.component';
import { DashboardUserDetailsComponent } from './pages/dashboard-group-users/dashboard-users/dashboard-user-details/dashboard-user-details.component';
import { DashboardUserHistoryDetailsComponent } from './pages/dashboard-group-users/dashboard-users/dashboard-user-details/dashboard-user-history-details/dashboard-user-history-details.component';
import { DashboardGroupRegisterComponent } from './pages/dashboard-group-users/dashboard-groups/dashboard-group-register/dashboard-group-register.component';
import { DashboardCompaniesComponent } from './pages/dashboard-companies/dashboard-companies.component';
import { DashboardCompaniesDetailsComponent } from './pages/dashboard-companies/dashboard-companies-details/dashboard-companies-details.component';
import { DashboardCompanyComponent } from './pages/dashboard-company/dashboard-company.component';
import { DashboardCompaniesRegisterBondComponent } from './pages/dashboard-companies/dashboard-companies-register-bond/dashboard-companies-register-bond.component';
import { DashboardCompaniesResumeComponent } from './pages/dashboard-companies/dashboard-companies-resume/dashboard-companies-resume.component';
import { DashboardCompaniesGroupDetailsComponent } from './pages/dashboard-companies/dashboard-companies-group-details/dashboard-companies-group-details.component';
import { DashboardCompaniesUserDetailsComponent } from './pages/dashboard-companies/dashboard-companies-user-details/dashboard-companies-user-details.component';
import { DashboardPermissionsComponent } from './pages/dashboard-permissions/dashboard-permissions.component';
import { DashboardPermissionsListDetailsComponent } from './pages/dashboard-permissions-list/dashboard-permissions-list-details/dashboard-permissions-list-details.component';
import { DashboardPermissionsListRegisterComponent } from './pages/dashboard-permissions-list/dashboard-permissions-list-register/dashboard-permissions-list-register.component';
import { DashboardPermissionsListComponent } from './pages/dashboard-permissions-list/dashboard-permissions-list.component';
import { DashboardDraftsVersionsComponent } from './pages/dashboard-drafts-versions/dashboard-drafts-versions.component';
import { DashboardDraftsVersionsFormComponent } from './pages/dashboard-drafts-versions-form/dashboard-drafts-versions-form.component';
import { DashboardDraftsVariablesListComponent } from './pages/dashboard-drafts-variables-list/dashboard-drafts-variables-list.component';
import { DashboardDraftsModelsListComponent } from './pages/dashboard-drafts-models-list/dashboard-drafts-models-list.component';
import { DashboardDraftsFormComponent } from './pages/dashboard-drafts-form/dashboard-drafts-form.component';
import { DashboardDraftsBondsComponent } from './pages/dashboard-drafts-bonds/dashboard-drafts-bonds.component';
import { DashboardDraftsBondsFormComponent } from './pages/dashboard-drafts-bonds-form/dashboard-drafts-bonds-form.component';
const getSignupRoutes = (name: string, role: string): Routes => [
  {
    path: 'basic',
    canActivate: [UnauthGuard],
    component: SignupUnifiedBasicComponent,
    data: {
      title: `Cadastro ${name}`,
      redirectTo: '/app/dashboard',
    },
  },
  {
    path: 'basic/:token',
    canActivate: [],
    component: SignupUnifiedBasicComponent,
    data: {
      title: `Cadastro ${name}`,
      redirectTo: '/app/dashboard',
    },
  },
  {
    path: 'pf/:id',
    canActivate: [AuthGuard],
    component: SignupUnifiedPersonComponent,
    data: {
      title: `Cadastro ${name} - PF`,
    },
  },
  {
    path: 'pj/:id',
    canActivate: [AuthGuard],
    component: SignupUnifiedCompanyComponent,
    data: {
      title: `Cadastro ${name} - PJ`,
    },
  },
];

const routes: Routes = [
  {
    path: 'app',
    component: DashSidebarComponent,
    children: [
      {
        path: 'me',
        component: RedirectUserComponent,
      },
      {
        path: 'details',
        children: [
          {
            path: ':id',
            component: DashboardApprovalComponent,
            data: {
              title: 'Detalhes',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          {
            path: 'assignor/:id',
            component: DashboardApprovalComponent,
            data: {
              title: 'Painel Cedente',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          {
            path: 'shareholder/:id',
            component: DashboardApprovalComponent,
            data: {
              title: 'Painel Cotista',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          {
            path: 'representative/:id',
            component: DashboardApprovalComponent,
            data: {
              title: 'Painel Cotista',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          //   {
          //     path: 'representative/:id',
          //     component: DashboardRepresentativeApprovalComponent,
          //     data: {
          //       title: 'Painel Representante',
          //       guardRole: 'ADM',
          //       redirectTo: '/app/dashboard',
          //     },
          //   },
          {
            path: 'provider/:id',
            component: DashboardApprovalComponent,
            data: {
              title: 'Painel Prestador de Serviço',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          {
            path: 'assignor/:id/:token',
            component: DashboardApprovalComponent,
            data: {
              title: 'Painel Cedente',
            },
          },
          {
            path: 'shareholder/:id/:token',
            component: DashboardApprovalComponent,
            data: {
              title: 'Painel Cotista',
            },
          },
          {
            path: 'provider/:id/:token',
            component: DashboardApprovalComponent,
            data: {
              title: 'Painel Prestador de Serviço',
            },
          },
          {
            path: 'representative/:id/:token',
            component: DashboardApprovalComponent,
            data: {
              title: 'Painel Representante',
            },
          },
        ],
      },

      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        data: {
          redirectTo: '/login',
        },
        children: [
          {
            path: '',
            // canActivate: ,
            component: DashboardComponent,
            data: {
              title: 'Painel',
              redirectTo: '/login',
            },
          },

          {
            path: 'fund/approval/:id',
            component: DashboardFundApprovalComponent,
            data: {
              title: 'Painel Fundo',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          {
            path: 'fund/approval/:id/model',
            canActivate: [RoleGuard],
            component: DashboardDocumentModelComponent,
            data: {
              title: 'Modelo de documento',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          {
            path: 'fund/approval/:id/model/:templateId',
            canActivate: [RoleGuard],
            component: DashboardDocumentModelComponent,
            data: {
              title: 'Modelo de documento',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          {
            path: 'funds',
            canActivate: [RoleGuard],
            component: DashboardFundsComponent,
            data: {
              title: 'Painel Fundos',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          {
            path: 'providers',
            canActivate: [RoleGuard],
            component: DashboardProvidersComponent,
            data: {
              title: 'Painel Prestador de Serviço',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          {
            path: ':role/list',
            canActivate: [RoleGuard],
            component: DashboardUserListComponent,
            data: {
              title: 'Lista de pendentes',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
        ],
      },
      {
        path: 'registers',
        children: [
          {
            path: '',
            canActivate: [AuthGuard],
            component: DashboardUserListComponent,
            data: {
              title: 'Lista de cadastros',
              redirectTo: '/login',
            },
          },
        ],
      },
      {
        path: 'security',
        children: [
          {
            path: '',
            canActivate: [CompleteGuard],
            component: DashboardSecurityComponent,
            data: {
              title: 'Segurança',
              redirectTo: '/app/dashboard',
            },
          },
        ],
      },
      {
        path: 'funds',
        data: {
          title: 'Fundos',
          breadcrumb: 'Fundos',
        },
        children: [
          {
            path: '',
            // canActivate: [CompleteGuard, RoleGuard],
            component: DashboardOrganizationComponent,
            data: {
              title: 'Fundos',
              breadcrumb: 'Fundos',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          {
            path: 'new',
            // canActivate: [RoleGuard],
            component: DashboardFundApprovalRegisterComponent,
            data: {
              title: 'Novo Fundo',
              breadcrumb: 'Novo',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          {
            path: 'approval/:id',
            // canActivate: [RoleGuard],
            component: DashboardFundApprovalComponent,
            data: {
              title: 'Detalhes do Fundo',
              breadcrumb: 'Aprovação',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          {
            path: 'edit/:id',
            // canActivate: [RoleGuard],
            component: DashboardFundApprovalRegisterComponent,
            data: {
              title: 'Editar Fundo',
              breadcrumb: 'Editar',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          {
            path: 'approval/:id/model',
            canActivate: [RoleGuard],
            component: DashboardDocumentModelComponent,
            data: {
              title: 'Modelo de documento',
              breadcrumb: 'Modelo',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
          {
            path: 'approval/:id/model/:templateId',
            canActivate: [RoleGuard],
            component: DashboardDocumentModelComponent,
            data: {
              title: 'Modelo de documento',
              breadcrumb: 'Modelo',
              guardRole: 'ADM',
              redirectTo: '/app/dashboard',
            },
          },
        ],
      },
      {
        path: 'request-access',
        data: {
          title: 'Solicições de acesso',
          guardRole: 'ADM',
          redirectTo: '/app/dashboard',
        },
        children: [
          {
            path: '',
            component: DashboardRequestAcessComponent,
            data: {
              title: 'Solicições de acesso',
            },
          },
        ],
      },
      {
        path: 'permissions',
        data: {
          title: 'Permissões',
          breadcrumb: 'Permissões',
          guardRole: 'ADM',
          redirectTo: '/app/dashboard',
        },
        children: [
          {
            path: '',
            component: DashboardPermissionsComponent,
            data: {
              title: 'Permissões',
              breadcrumb: 'Permissões',
            },
          },
          {
            path: 'list',
            component: DashboardPermissionsListComponent,
            data: {
              title: 'Controle de permissões',
              breadcrumb: 'Controle de permissões',
            },
          },
          {
            path: 'details/:id',
            component: DashboardPermissionsListDetailsComponent,
            data: {
              title: 'Detalhes do grupo de permissão',
              breadcrumb: 'Detalhes',
            },
          },
          {
            path: 'new',
            component: DashboardPermissionsListRegisterComponent,
            data: {
              title: 'Novo grupo de permissões',
              breadcrumb: 'Novo',
            },
          },
          {
            path: 'update/:id',
            component: DashboardPermissionsListRegisterComponent,
            data: {
              title: 'Edição de grupo de permissões',
              breadcrumb: 'Editar',
            },
          },
          {
            path: 'companies',
            data: {
              breadcrumb: 'Empresas',
            },
            children: [
              {
                path: '',
                component: DashboardCompaniesComponent,
                data: {
                  title: 'Empresas',
                  breadcrumb: 'Empresas',
                },
              },
              {
                path: 'details/:id',
                component: DashboardCompaniesDetailsComponent,
                data: {
                  title: 'Detalhes da empresa',
                  breadcrumb: 'Detalhes da empresa',
                },
              },
              {
                path: ':id/bond',
                component: DashboardCompaniesRegisterBondComponent,
                data: {
                  title: 'Vincular perfis de usuário',
                  breadcrumb: 'Vincular perfis',
                },
              },
              {
                path: ':id/bond/resume',
                component: DashboardCompaniesResumeComponent,
                data: {
                  title: 'Vincular perfis de usuário',
                  breadcrumb: 'Resumo',
                },
              },
              {
                path: ':id/bond/group/:groupId/resume',
                component: DashboardCompaniesResumeComponent,
                data: {
                  title: 'Vincular perfis de usuário',
                  breadcrumb: 'Resumo',
                },
              },
              {
                path: ':id/group/details/:groupId',
                component: DashboardCompaniesGroupDetailsComponent,
                data: {
                  title: 'Detalhes do grupo',
                  breadcrumb: 'Detalhes do grupo',
                },
              },
              {
                path: ':id/bond/group/:groupId',
                component: DashboardCompaniesRegisterBondComponent,
                data: {
                  title: 'Vincular perfis de usuário',
                  breadcrumb: 'Vincular perfis',
                },
              },
              {
                path: ':id/user/details/:userId',
                component: DashboardCompaniesUserDetailsComponent,
                data: {
                  title: 'Detalhes de usuário',
                  breadcrumb: 'Detalhes de usuário',
                },
              },
            ],
          },
          {
            path: 'groups',
            data: {
              breadcrumb: 'Perfis de acessos',
            },
            children: [
              {
                path: '',
                component: DashboardGroupUsersComponent,
                data: {
                  title: 'Usuários e Grupos',
                  breadcrumb: 'Perfis de acessos',
                },
              },
              {
                path: 'new',
                component: DashboardGroupRegisterComponent,
                data: {
                  title: 'Novo grupo',
                  breadcrumb: 'Novo',
                },
              },
              {
                path: 'update/:id',
                component: DashboardGroupRegisterComponent,
                data: {
                  title: 'Edição de grupo',
                  breadcrumb: 'Editar',
                },
              },
              {
                path: 'user/details/:id',
                component: DashboardUserDetailsComponent,
                data: {
                  title: 'Usuários e Grupos',
                  breadcrumb: 'Usuários',
                },
              },
              {
                path: 'user/details/:id/history/:historyId',
                component: DashboardUserHistoryDetailsComponent,
                data: {
                  title: 'Usuários e Grupos',
                  breadcrumb: 'Histórico',
                },
              },
            ],
          },
        ],
      },
      {
        path: 'settings',
        // canActivate: [RoleGuard],
        data: {
          title: 'Configurações',
          guardRole: 'ADM',
          redirectTo: '/app/dashboard',
        },
        children: [
          {
            path: '',
            component: DashboardSettingsComponent,
            data: {
              title: 'Configurações',
            },
          },
          {
            path: 'agents',
            component: DashboardAgentsComponent,
            data: {
              title: 'Agentes',
            },
          },

          {
            path: 'permissions',
            children: [
              //   {
              //     path: 'history',
              //     children: [
              //       {
              //         path: 'details/:id',
              //         component: DashboardHistoryDetailsComponent,
              //         data: {
              //           title: 'Detalhes do histórico',
              //         },
              //       },
              //     ],
              //   },
              //   {
              //     path: 'group',
              //     children: [
              //       {
              //         path: 'details/:id',
              //         component: DashboardUsersGroupDetailsComponent,
              //         data: {
              //           title: 'Detalhes do grupo',
              //         },
              //       },
              //     ],
              //   },
            ],
          },
          {
            path: 'funds',
            component: DashboardZeroingFundsComponent,
            data: {
              title: 'Fundos de zeragem',
            },
          },
          {
            path: 'audits',
            component: DashboardAuditComponent,
            data: {
              title: 'Auditorias',
            },
          },
          {
            path: 'documents',
            component: DashboardDocumentsComponent,
            data: {
              title: 'Documentos',
            },
          },
        ],
      },
      {
        path: 'company',
        component: DashboardCompanyComponent,
        data: {
          title: 'Minha Empresa',
        },
      },
      {
        path: 'accounts',
        data: {
          title: 'Meus cadastros',
        },
        children: [
          {
            path: '',
            component: DashboardAccountsComponent,
          },
        ],
      },
      {
        path: 'invites',
        data: {
          title: 'Convites',
        },
        children: [
          {
            path: '',
            component: DashboardInvitesComponent,
          },
        ],
      },
      {
        path: 'drafts',
        data: {
          title: 'Minutas',
        },
        children: [
          {
            path: '',
            component: DashboardDraftsComponent,
          },
          {
            path: 'types',
            component: DashboardDraftsVersionsComponent,
          },
          {
            path: 'types/new',
            component: DashboardDraftsVersionsFormComponent,
          },
          {
            path: 'types/:id',
            component: DashboardDraftsVersionsFormComponent,
          },
          {
            path: 'variables',
            component: DashboardDraftsVariablesListComponent,
          },
          {
            path: 'models',
            component: DashboardDraftsModelsListComponent,
          },
          {
            path: 'models/new',
            component: DashboardDraftsFormComponent,
          },
          {
            path: 'models/:id',
            component: DashboardDraftsFormComponent,
          },
          {
            path: 'bonds',
            component: DashboardDraftsBondsComponent,
          },
          {
            path: 'bonds/:id',
            component: DashboardDraftsBondsFormComponent,
          },
          {
            path: 'bonds/new',
            component: DashboardDraftsBondsFormComponent,
          },
          {
            path: 'witnesses',
            component: DashboardWitnessesComponent,
            data: {
              title: 'Testemunhas',
              breadcrumb: 'Testemunhas',
            },
          },
        ],
      },
    ],
  },
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [UnauthGuard],
        data: {
          title: 'Autenticação',
          redirectTo: '/app/dashboard',
        },
      },
      {
        path: 'login/:token',
        component: LoginComponent,
        canActivate: [UnauthGuard],
        data: {
          title: 'Autenticação',
          redirectTo: '/app/dashboard',
        },
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
        canActivate: [UnauthGuard],
        data: {
          title: 'Recuperação de senha',
          redirectTo: '/app/dashboard',
        },
      },
      {
        path: 'signup',
        children: [
          {
            path: 'assignor',
            children: getSignupRoutes('Cedente', 'assignor'),
          },
          {
            path: 'provider',
            children: getSignupRoutes('Prestador de Serviço', 'provider'),
          },
          {
            path: 'shareholder',
            children: getSignupRoutes('Cotista', 'shareholder'),
          },
          {
            path: 'guarantor',
            children: getSignupRoutes('Avalista', 'guarantor'),
          },
        ],
      },
      {
        path: 'status',
        canActivate: [AuthGuard],
        data: { redirectTo: '/login' },
        children: [
          {
            path: 'pf',
            component: SignupStatusComponent,
            data: {
              title: 'Status PF',
            },
          },
          {
            path: 'pj',
            component: SignupStatusComponent,
            data: {
              title: 'Status PJ',
            },
          },
        ],
      },
    ],
  },
  { path: '**', pathMatch: 'full', component: NotFoundComponent },
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
